import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Toggle from 'react-bootstrap-toggle'

import ClubFeedNotificationDialog, { CONFIRM_MODE } from '../../../shared/components/club_feed_notification_dialog'
import { clubFeedChannelsArmed } from '../../../shared/club_feed_channels'

class RoundProgress extends Component {
  constructor(props){
    super(props)
    this.state = {
      clubFeedConfirmPending: false,
      clubFeedPendingStatus: null,
    }
  }

  componentDidMount() {
    window.glg.new_design_shared.initBootstrapCheckboxes()
  }

  requestToggleTeeSheet = () => {
    const { roundOptions, club_feed: clubFeed } = this.props.content

    if (!roundOptions.show_parings_in_event_portal.status && clubFeedChannelsArmed(clubFeed && clubFeed.channels)) {
      this.setState({ clubFeedConfirmPending: true })
    } else {
      this.toggleTeeSheet()
    }
  }

  toggleTeeSheet = (data = {}) => {
    const { roundOptions, roundId } = this.props.content
    this.props.toggleRoundOptions(roundOptions.show_parings_in_event_portal.path, 'show_parings_in_event_portal', roundId, data)
  }

  closeClubFeedConfirm = () => this.setState({ clubFeedConfirmPending: false })

  sendClubFeedConfirm = () => {
    this.closeClubFeedConfirm()
    this.toggleTeeSheet()
  }

  skipClubFeedConfirm = () => {
    this.closeClubFeedConfirm()
    this.toggleTeeSheet({ skip_notifications: 1 })
  }

  clubFeedPrompts = (status) => {
    const { roundOptions } = this.props.content

    if (status === 'in progress') {
      return true
    }

    return status === 'completed' && Boolean(roundOptions.show_events_in_results_portal.status)
  }

  statusPath = (status) => {
    const { roundStates } = this.props.content

    if (status === 'in progress') {
      return roundStates.round_in_progress.path
    }

    return status === 'completed' ? roundStates.round_completed.path : roundStates.round_not_started.path
  }

  requestSetRoundStatus = (status) => {
    const { club_feed_leaderboard: clubFeedLeaderboard } = this.props.content

    if (this.clubFeedPrompts(status) && clubFeedChannelsArmed(clubFeedLeaderboard && clubFeedLeaderboard.channels)) {
      this.setState({ clubFeedPendingStatus: status })
    } else {
      this.setRoundStatus(status)
    }
  }

  setRoundStatus = (status, data = {}) => {
    this.props.setRoundStatus(status, this.statusPath(status), this.props.content.roundId, data)
  }

  clubFeedStatusAction = () => (
    this.state.clubFeedPendingStatus === 'in progress' ? 'leaderboard_live' : 'results_finalized'
  )

  closeClubFeedStatusConfirm = () => this.setState({ clubFeedPendingStatus: null })

  sendClubFeedStatusConfirm = () => {
    const status = this.state.clubFeedPendingStatus
    this.closeClubFeedStatusConfirm()
    this.setRoundStatus(status)
  }

  skipClubFeedStatusConfirm = () => {
    const status = this.state.clubFeedPendingStatus
    this.closeClubFeedStatusConfirm()
    this.setRoundStatus(status, { skip_notifications: 1 })
  }

  render() {
    const { title, links, roundToggleText, roundOptions, roundStates, roundProgress, roundId, club_feed: clubFeed, club_feed_leaderboard: clubFeedLeaderboard } = this.props.content

    return (
      <div className='widget-content-default widget-content-rounds widget-content-round-progress'>
        <div className='title'>
          { title }

          <a href={ links.round_profile.path } className='btn btn-primary widget-white-title-button'>
            { links.round_profile.name }
          </a>
        </div>
        <div className='content'>
          <div className='round-options'>
            { roundOptions.show_parings_in_event_portal.name }
            <Toggle onClick={ this.requestToggleTeeSheet }
                    on={ roundToggleText.yes }
                    off={ roundToggleText.no }
                    className='rounded'
                    disabled={ roundOptions.show_parings_in_event_portal.disabled }
                    active={ roundOptions.show_parings_in_event_portal.status } />
          </div>

          <div className='round-options'>
            { roundOptions.enable_digital_scorecards.name }
            <Toggle onClick={ () => { this.props.toggleRoundOptions(roundOptions.enable_digital_scorecards.path, 'enable_digital_scorecards', roundId) } }
                    on={ roundToggleText.yes }
                    off={ roundToggleText.no }
                    className='rounded'
                    disabled={ roundOptions.enable_digital_scorecards.disabled }
                    active={ roundOptions.enable_digital_scorecards.status } />
          </div>

          <div className='round-options'>
            { roundOptions.enable_mobile_score_entry.name }
            <Toggle onClick={ () => { this.props.toggleRoundOptions(roundOptions.enable_mobile_score_entry.path, 'enable_mobile_score_entry', roundId) } }
                    on={ roundToggleText.yes }
                    off={ roundToggleText.no }
                    className='rounded'
                    disabled={ roundOptions.enable_mobile_score_entry.disabled }
                    active={ roundOptions.enable_mobile_score_entry.status } />
          </div>

          <div className='round-options'>
            { roundOptions.enable_walking_scorer.name }
            <Toggle onClick={ () => { this.props.toggleRoundOptions(roundOptions.enable_walking_scorer.path, 'enable_walking_scorer', roundId) } }
                    on={ roundToggleText.yes }
                    off={ roundToggleText.no }
                    className='rounded'
                    disabled={ roundOptions.enable_walking_scorer.disabled }
                    active={ roundOptions.enable_walking_scorer.status } />
          </div>

          <div className='round-options'>
            { roundOptions.show_events_in_results_portal.name }
            <Toggle onClick={ () => { this.props.toggleRoundOptions(roundOptions.show_events_in_results_portal.path, 'show_events_in_results_portal', roundId) } }
                    on={ roundToggleText.yes }
                    off={ roundToggleText.no }
                    className='rounded'
                    disabled={ roundOptions.show_events_in_results_portal.disabled }
                    active={ roundOptions.show_events_in_results_portal.status } />
          </div>

          <div className='round-status'>
            <div className='btn-group' role='group'>
              <button
                type='button'
                className={ `btn btn-default btn-progress ${roundProgress === 'not started' ? 'active' : ''}` }
                onClick={ () => this.requestSetRoundStatus('not started') } >
                { roundStates.round_not_started.name }
              </button>
              <button
                type='button'
                className={ `btn btn-default btn-progress ${roundProgress === 'in progress' ? 'active' : ''}` }
                onClick={ () => this.requestSetRoundStatus('in progress') } >
                { roundStates.round_in_progress.name }
              </button>
              <button
                type='button'
                className={ `btn btn-default btn-progress ${roundProgress === 'completed' ? 'active' : ''}` }
                onClick={ () => this.requestSetRoundStatus('completed') } >
                { roundStates.round_completed.name }
              </button>
            </div>
          </div>
        </div>

        <ClubFeedNotificationDialog
          mode={ CONFIRM_MODE }
          action='tee_sheet_published'
          show={ this.state.clubFeedConfirmPending }
          channels={ clubFeed && clubFeed.channels }
          product={ clubFeed && clubFeed.product }
          settingsUrl={ clubFeed && clubFeed.settings_url }
          learnMoreUrl={ clubFeed && clubFeed.learn_more_url }
          onClose={ this.closeClubFeedConfirm }
          onSend={ this.sendClubFeedConfirm }
          onSkip={ this.skipClubFeedConfirm }
        />

        <ClubFeedNotificationDialog
          mode={ CONFIRM_MODE }
          action={ this.clubFeedStatusAction() }
          show={ Boolean(this.state.clubFeedPendingStatus) }
          channels={ clubFeedLeaderboard && clubFeedLeaderboard.channels }
          product={ clubFeedLeaderboard && clubFeedLeaderboard.product }
          settingsUrl={ clubFeedLeaderboard && clubFeedLeaderboard.settings_url }
          learnMoreUrl={ clubFeedLeaderboard && clubFeedLeaderboard.learn_more_url }
          onClose={ this.closeClubFeedStatusConfirm }
          onSend={ this.sendClubFeedStatusConfirm }
          onSkip={ this.skipClubFeedStatusConfirm }
        />
      </div>
    )
  }
}

RoundProgress.propTypes = {
  content: PropTypes.object,
  setRoundStatus: PropTypes.func,
  toggleRoundOptions: PropTypes.func,
}


RoundProgress.defaultProps = {
  content: {
    show_parings_in_event_portal: {
      status: false,
      disabled: true,
      path: '#',
    },
    enable_digital_scorecards: {
      status: false,
      disabled: true,
      path: '#',
    },
    enable_mobile_score_entry: {
      status: false,
      disabled: true,
      path: '#',
    },
    enable_walking_scorer: {
      status: false,
      disabled: true,
      path: '#',
    },
    show_events_in_results_portal: {
      status: false,
      disabled: true,
      path: '#',
    },
    round_not_started_path: '#',
    round_in_progress_path: '#',
    round_completed_path: '#',
    roundId: '',
    round_progress: 'not started',
  },
}

export default RoundProgress
